// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonStack {
    justify-content: flex-end;
    flex-shrink: 0;
}
.workflowedit-wrapper {
    display: grid;
    height: 100%;
    width: 100%;
    grid-template-rows: 1fr auto;
    padding: 10px;
}
.workflowedit-content {
    grid-row-start: 1;
    grid-row-end: 1;
    overflow: hidden;
}
.workflowedit-actions {
    grid-row-start: 2;
    grid-row-end: 2;
    padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/workflow.edit.dialog.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".buttonStack {\n    justify-content: flex-end;\n    flex-shrink: 0;\n}\n.workflowedit-wrapper {\n    display: grid;\n    height: 100%;\n    width: 100%;\n    grid-template-rows: 1fr auto;\n    padding: 10px;\n}\n.workflowedit-content {\n    grid-row-start: 1;\n    grid-row-end: 1;\n    overflow: hidden;\n}\n.workflowedit-actions {\n    grid-row-start: 2;\n    grid-row-end: 2;\n    padding-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
